import { Action } from 'redux';

import { DeleteContents, DeleteContentsSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface DeleteContentAction extends Action {
  contentArray: IContentInfo[];
}

export function deleteContentsAction(contentArray: IContentInfo[]): DeleteContentAction {
  return {
    type: DeleteContents,
    contentArray: contentArray
  };
}

export function deleteContentAction(content: IContentInfo): DeleteContentAction {
  return deleteContentsAction([content]);
}

export const isDeleteContentAction = isActionFactory<DeleteContentAction>(DeleteContents);

export interface DeleteContentSucceededAction extends Action {}

export function deleteContentSucceeded(): DeleteContentSucceededAction {
  return {
    type: DeleteContentsSucceeded
  };
}

export const isDeleteContentSucceeded = isActionFactory<DeleteContentSucceededAction>(DeleteContentsSucceeded);
